import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { FileInfo, FileUploadError, GalaxyUploaderComponent } from '@vendasta/galaxy/uploader';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'orders-attachments-dialog',
  templateUrl: 'attachments-dialog.component.html',
  styleUrls: ['./attachments-dialog.component.scss'],
  standalone: false,
})
export class AttachmentsDialogComponent {
  numberFilesUploaded = 0;
  maxNumberFiles = 100;
  files: FileInfo[] = [];
  loading$$ = new BehaviorSubject(false);

  @ViewChild('glxyUploader') uploader: GalaxyUploaderComponent;

  constructor(
    private translate: TranslateService,
    private snack: SnackbarService,
    public dialogRef: MatDialogRef<AttachmentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { uploadUrl: string },
  ) {}

  onError(event: FileUploadError): void {
    this.snack.openErrorSnack(event.error.message);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onUpload(event: any): void {
    this.numberFilesUploaded++;
    if (this.files.length === this.numberFilesUploaded) {
      this.loading$$.next(false);
      const successMessage = this.translate.instant('LIB_ORDERS.COMMON.ORDER_DETAILS.SUCCESSFUL_UPLOAD', {
        numberFilesUploaded: this.numberFilesUploaded,
      });
      this.snack.openSuccessSnack(successMessage);
      this.dialogRef.close(this.files);
    }
  }

  onFilesChanged(files: FileInfo[]): void {
    this.files = files;
  }

  onUploadAndClose(): void {
    this.loading$$.next(true);
    this.uploader.uploadQueuedFiles();
  }
}
